/**
 * matrix-relations.json SSOT 타입 (선언층)
 */

export type MatrixRelationType = 'F' | 'R' | 'T' | 'D' | 'E' | 'M';

export interface MatrixRelation {
  source: string;
  target: string;
  type: MatrixRelationType;
  description?: string;
}

export interface MatrixRelationsDocument {
  version: string;
  schema: string;
  relations: MatrixRelation[];
}

export interface NetworkEdge {
  id: string;
  source: string;
  target: string;
  type: MatrixRelationType;
  description?: string;
  direction: 'outgoing' | 'incoming';
}

/** 관계 타입 → cross-domain FieldGroupType (DomainTableConfigManager 와 동일) */
export const MATRIX_RELATION_TYPE_TO_GROUP: Record<
  Exclude<MatrixRelationType, 'M'>,
  'finance_link' | 'reference_link' | 'trigger_link' | 'data_mirror' | 'state_signal'
> = {
  F: 'finance_link',
  R: 'reference_link',
  T: 'trigger_link',
  D: 'data_mirror',
  E: 'state_signal',
} as const;

export interface CrossDomainRelationHints {
  financeLinks: MatrixRelation[];
  referenceTargets: MatrixRelation[];
  triggers: MatrixRelation[];
  dataMirrors: MatrixRelation[];
  stateSignals: MatrixRelation[];
}
